<template>
  <div class="eb-pt-row-login">
    <div class="row justify-content-md-center mt-5">
      <div :class="formContainerClass">
        <div class="col-12">
          <div class="row">
            <div class="col-12 text-center">
              <p class="my-4">
                <b class="h5">Congratulations you're now connected to Facebook.</b>
              </p>
              <p>
                Do you have an existing account to link this to?
              </p>
            </div>
          </div>
          <div class="row justify-content-md-center my-4">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block primary btn-rounded"
                @click="createAccount"
              >
                No - Create new account
              </button>
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block primary-color driver-button-color btn-rounded gf-driver-button"
                @click="userHasAccount"
              >
                Yes - Login and Link
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useAppRouter from '../../composables/useAppRouter';

export default {
name: 'FacebookConnect',
props: {
  accessToken: {
    type: String,
    default: '',
  },
  formContainerClass: {
    type: String,
    default: '',
  },
},
data() {
  return {
    accountAccessToken :'',
    router: useAppRouter,
  };
},
mounted: function() {
  if (this.router().getRouteParams('accessToken') && this.router().getRouteParams('accessToken').length > 0) {            
    this.accountAccessToken = this.router().getRouteParams('accessToken')            
  }
},
methods: {
  userHasAccount() {
    this.router().show('login', { accountLink: true, accessToken: this.accountAccessToken })
  },

  createAccount() {
    this.router().show('register', { accountLink: true, accessToken: this.accountAccessToken })
  }
}
}
</script>

<style scoped>
.btn-rounded {
    border-radius: 26px;
}
</style>
